import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(public router: Router) { }
    canActivate(): boolean {
        if (!this.isAuthenticated()) {
            this.router.navigate(['register']);
            return false;
        }
        return true;
    }

    isAuthenticated() {
        const email = localStorage.getItem('email');
        console.log("email--->", email)
        if (email) {
            return true;
        } else {
            return false;
        }
    }
}